import { Box, Typography } from "@mui/material";
import { isEmpty } from "lodash";
import { useState, useEffect } from "react";
import { getNotificationdataMetadata } from "./utils";

const root = () => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& .meta": {
      display: "flex",
      alignItems: "center",
      "& img": {
        width: "36px",
      },
    },
  };
};

const typeList = ["critical", "error", "warning", "notice"];

const initialNotification = {
  severity: "",
};

const HomeMessage = ({ notificationList = [], showNoMessage = false }) => {
  const [notificationItem, setNotificationItem] = useState(initialNotification);
  const [metadata, setMetadata] = useState();

  useEffect(() => {
    const displayList = notificationList?.filter((it) => it.display);
    if (displayList?.length === 0) {
      setNotificationItem(initialNotification);
    } else {
      for (let severity of typeList) {
        const item = displayList.find((it) => it.severity === severity);
        if (item) {
          setNotificationItem(item);
          break;
        }
      }
    }
  }, [notificationList]);

  useEffect(() => {
    setMetadata(getNotificationdataMetadata(notificationItem));
  }, [notificationItem]);

  if (isEmpty(notificationItem.severity)) {
    if (showNoMessage) {
      return (
        <Typography variant="subtitle1" fontWeight={500} textAlign="center">
          None at this time
        </Typography>
      );
    } else {
      return null;
    }
  }

  return (
    <Box sx={() => root()} mt={0.5}>
      <Box className="meta" mr={1}>
        <img src={metadata?.icon} />
        <Typography variant="subtitle1" fontWeight={700}>
          {metadata?.label}
        </Typography>
      </Box>
      <Typography variant="body1">{notificationItem?.name}</Typography>
    </Box>
  );
};

export default HomeMessage;
